import { render, staticRenderFns } from "./addDocumentModal.vue?vue&type=template&id=03d9dcf9"
import script from "./addDocumentModal.vue?vue&type=script&lang=js"
export * from "./addDocumentModal.vue?vue&type=script&lang=js"
import style0 from "./addDocumentModal.vue?vue&type=style&index=0&id=03d9dcf9&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0_supports-_c8986591775dd8171f89195ce4da2f89/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports